// Depends
import { route, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/dependents'

const dependentRoutes = [
  route('edit', '/:id/edit', Create, meta('Editar dependente', true, 'guest')),
  route('create', '/create', Create, meta('Adicionar novo dependente', true, 'guest')),
  route('index', '/index', Index, meta('Lista de dependentes', true, 'guest'))
]

export default dependentRoutes



// WEBPACK FOOTER //
// ./src/app/settings/dependents/routes.js